import _asyncToGenerator from "/home/runner/work/mkt-main-website/mkt-main-website/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/home/runner/work/mkt-main-website/mkt-main-website/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/mkt-main-website/mkt-main-website/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _get from "/home/runner/work/mkt-main-website/mkt-main-website/node_modules/@babel/runtime/helpers/esm/get.js";
import _inherits from "/home/runner/work/mkt-main-website/mkt-main-website/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/home/runner/work/mkt-main-website/mkt-main-website/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/runner/work/mkt-main-website/mkt-main-website/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import _regeneratorRuntime from "/home/runner/work/mkt-main-website/mkt-main-website/node_modules/@babel/runtime/regenerator/index.js";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
/* @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { property } from 'lit/decorators.js';
import { USDZExporter } from 'three/examples/jsm/exporters/USDZExporter.js';
import { IS_AR_QUICKLOOK_CANDIDATE, IS_SCENEVIEWER_CANDIDATE, IS_WEBXR_AR_CANDIDATE } from '../constants.js';
import { $needsRender, $progressTracker, $renderer, $scene, $shouldAttemptPreload, $updateSource } from '../model-viewer-base.js';
import { enumerationDeserializer } from '../styles/deserializers.js';
import { ARStatus, ARTracking } from '../three-components/ARRenderer.js';
import { waitForEvent } from '../utilities.js';
var isWebXRBlocked = false;
var isSceneViewerBlocked = false;
var noArViewerSigil = '#model-viewer-no-ar-fallback';
var deserializeARModes = enumerationDeserializer(['quick-look', 'scene-viewer', 'webxr', 'none']);
var DEFAULT_AR_MODES = 'webxr scene-viewer quick-look';
var ARMode = {
  QUICK_LOOK: 'quick-look',
  SCENE_VIEWER: 'scene-viewer',
  WEBXR: 'webxr',
  NONE: 'none'
};
var $arButtonContainer = Symbol('arButtonContainer');
var $enterARWithWebXR = Symbol('enterARWithWebXR');
export var $openSceneViewer = Symbol('openSceneViewer');
export var $openIOSARQuickLook = Symbol('openIOSARQuickLook');
var $canActivateAR = Symbol('canActivateAR');
var $arMode = Symbol('arMode');
var $arModes = Symbol('arModes');
var $arAnchor = Symbol('arAnchor');
var $preload = Symbol('preload');
var $onARButtonContainerClick = Symbol('onARButtonContainerClick');
var $onARStatus = Symbol('onARStatus');
var $onARTracking = Symbol('onARTracking');
var $onARTap = Symbol('onARTap');
var $selectARMode = Symbol('selectARMode');
var $triggerLoad = Symbol('triggerLoad');
export var ARMixin = function ARMixin(ModelViewerElement) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
  var ARModelViewerElement = /*#__PURE__*/function (_ModelViewerElement, _ref) {
    _inherits(ARModelViewerElement, _ModelViewerElement);
    var _super = _createSuper(ARModelViewerElement);
    function ARModelViewerElement() {
      var _this;
      _classCallCheck(this, ARModelViewerElement);
      _this = _super.apply(this, arguments);
      _this.ar = false;
      _this.arScale = 'auto';
      _this.arPlacement = 'floor';
      _this.arModes = DEFAULT_AR_MODES;
      _this.iosSrc = null;
      _this.xrEnvironment = false;
      _this[_a] = false;
      // TODO: Add this to the shadow root as part of this mixin's
      // implementation:
      _this[_b] = _this.shadowRoot.querySelector('.ar-button');
      _this[_c] = document.createElement('a');
      _this[_d] = new Set();
      _this[_e] = ARMode.NONE;
      _this[_f] = false;
      _this[_g] = function (event) {
        event.preventDefault();
        _this.activateAR();
      };
      _this[_h] = function (_ref2) {
        var status = _ref2.status;
        if (status === ARStatus.NOT_PRESENTING || _this[$renderer].arRenderer.presentedScene === _this[$scene]) {
          _this.setAttribute('ar-status', status);
          _this.dispatchEvent(new CustomEvent('ar-status', {
            detail: {
              status: status
            }
          }));
          if (status === ARStatus.NOT_PRESENTING) {
            _this.removeAttribute('ar-tracking');
          } else if (status === ARStatus.SESSION_STARTED) {
            _this.setAttribute('ar-tracking', ARTracking.TRACKING);
          }
        }
      };
      _this[_j] = function (_ref3) {
        var status = _ref3.status;
        _this.setAttribute('ar-tracking', status);
        _this.dispatchEvent(new CustomEvent('ar-tracking', {
          detail: {
            status: status
          }
        }));
      };
      _this[_k] = function (event) {
        if (event.data == '_apple_ar_quicklook_button_tapped') {
          _this.dispatchEvent(new CustomEvent('quick-look-button-tapped'));
        }
      };
      return _this;
    }
    _createClass(ARModelViewerElement, [{
      key: "canActivateAR",
      get: function get() {
        return this[$arMode] !== ARMode.NONE;
      }
    }, {
      key: "connectedCallback",
      value: function connectedCallback() {
        _get(_getPrototypeOf(ARModelViewerElement.prototype), "connectedCallback", this).call(this);
        this[$renderer].arRenderer.addEventListener('status', this[$onARStatus]);
        this.setAttribute('ar-status', ARStatus.NOT_PRESENTING);
        this[$renderer].arRenderer.addEventListener('tracking', this[$onARTracking]);
        this[$arAnchor].addEventListener('message', this[$onARTap]);
      }
    }, {
      key: "disconnectedCallback",
      value: function disconnectedCallback() {
        _get(_getPrototypeOf(ARModelViewerElement.prototype), "disconnectedCallback", this).call(this);
        this[$renderer].arRenderer.removeEventListener('status', this[$onARStatus]);
        this[$renderer].arRenderer.removeEventListener('tracking', this[$onARTracking]);
        this[$arAnchor].removeEventListener('message', this[$onARTap]);
      }
    }, {
      key: "update",
      value: function update(changedProperties) {
        _get(_getPrototypeOf(ARModelViewerElement.prototype), "update", this).call(this, changedProperties);
        if (changedProperties.has('arScale')) {
          this[$scene].canScale = this.arScale !== 'fixed';
        }
        if (changedProperties.has('arPlacement')) {
          this[$scene].updateShadow();
          this[$needsRender]();
        }
        if (changedProperties.has('arModes')) {
          this[$arModes] = deserializeARModes(this.arModes);
        }
        if (changedProperties.has('ar') || changedProperties.has('arModes') || changedProperties.has('src') || changedProperties.has('iosSrc')) {
          this[$selectARMode]();
        }
      }
      /**
       * Activates AR. Note that for any mode that is not WebXR-based, this
       * method most likely has to be called synchronous from a user
       * interaction handler. Otherwise, attempts to activate modes that
       * require user interaction will most likely be ignored.
       */
    }, {
      key: "activateAR",
      value: function () {
        var _activateAR = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                _context.t0 = this[$arMode];
                _context.next = _context.t0 === ARMode.QUICK_LOOK ? 3 : _context.t0 === ARMode.WEBXR ? 6 : _context.t0 === ARMode.SCENE_VIEWER ? 9 : 11;
                break;
              case 3:
                _context.next = 5;
                return this[$openIOSARQuickLook]();
              case 5:
                return _context.abrupt("break", 13);
              case 6:
                _context.next = 8;
                return this[$enterARWithWebXR]();
              case 8:
                return _context.abrupt("break", 13);
              case 9:
                this[$openSceneViewer]();
                return _context.abrupt("break", 13);
              case 11:
                console.warn('No AR Mode can be activated. This is probably due to missing \
configuration or device capabilities');
                return _context.abrupt("break", 13);
              case 13:
              case "end":
                return _context.stop();
            }
          }, _callee, this);
        }));
        function activateAR() {
          return _activateAR.apply(this, arguments);
        }
        return activateAR;
      }()
    }, {
      key: _ref,
      value: function () {
        var _value = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
          var _l, arMode, _iterator, _step, _value2, status;
          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                arMode = ARMode.NONE;
                if (!this.ar) {
                  _context2.next = 53;
                  break;
                }
                if (!(this.src != null)) {
                  _context2.next = 52;
                  break;
                }
                _iterator = _createForOfIteratorHelper(this[$arModes]);
                _context2.prev = 4;
                _iterator.s();
              case 6:
                if ((_step = _iterator.n()).done) {
                  _context2.next = 44;
                  break;
                }
                _value2 = _step.value;
                _context2.t0 = _value2 === 'webxr' && IS_WEBXR_AR_CANDIDATE && !isWebXRBlocked;
                if (!_context2.t0) {
                  _context2.next = 13;
                  break;
                }
                _context2.next = 12;
                return this[$renderer].arRenderer.supportsPresentation();
              case 12:
                _context2.t0 = _context2.sent;
              case 13:
                if (!_context2.t0) {
                  _context2.next = 16;
                  break;
                }
                arMode = ARMode.WEBXR;
                return _context2.abrupt("break", 44);
              case 16:
                _context2.t1 = _value2 === 'scene-viewer' && !isSceneViewerBlocked;
                if (!_context2.t1) {
                  _context2.next = 36;
                  break;
                }
                _context2.t2 = IS_SCENEVIEWER_CANDIDATE;
                if (_context2.t2) {
                  _context2.next = 35;
                  break;
                }
                _context2.t3 = navigator.userAgentData && navigator.userAgentData.getHighEntropyValues;
                if (!_context2.t3) {
                  _context2.next = 34;
                  break;
                }
                _context2.next = 24;
                return navigator.userAgentData.getHighEntropyValues(['formFactor']);
              case 24:
                _context2.t5 = _l = _context2.sent.formFactor;
                _context2.t4 = _context2.t5 === null;
                if (_context2.t4) {
                  _context2.next = 28;
                  break;
                }
                _context2.t4 = _l === void 0;
              case 28:
                if (!_context2.t4) {
                  _context2.next = 32;
                  break;
                }
                _context2.t6 = void 0;
                _context2.next = 33;
                break;
              case 32:
                _context2.t6 = _l.includes('XR');
              case 33:
                _context2.t3 = _context2.t6;
              case 34:
                _context2.t2 = _context2.t3;
              case 35:
                _context2.t1 = _context2.t2;
              case 36:
                if (!_context2.t1) {
                  _context2.next = 39;
                  break;
                }
                arMode = ARMode.SCENE_VIEWER;
                return _context2.abrupt("break", 44);
              case 39:
                if (!(_value2 === 'quick-look' && IS_AR_QUICKLOOK_CANDIDATE)) {
                  _context2.next = 42;
                  break;
                }
                arMode = ARMode.QUICK_LOOK;
                return _context2.abrupt("break", 44);
              case 42:
                _context2.next = 6;
                break;
              case 44:
                _context2.next = 49;
                break;
              case 46:
                _context2.prev = 46;
                _context2.t7 = _context2["catch"](4);
                _iterator.e(_context2.t7);
              case 49:
                _context2.prev = 49;
                _iterator.f();
                return _context2.finish(49);
              case 52:
                // The presence of ios-src overrides the absence of quick-look
                // ar-mode.
                if (arMode === ARMode.NONE && this.iosSrc != null && IS_AR_QUICKLOOK_CANDIDATE) {
                  arMode = ARMode.QUICK_LOOK;
                }
              case 53:
                if (arMode !== ARMode.NONE) {
                  this[$arButtonContainer].classList.add('enabled');
                  this[$arButtonContainer].addEventListener('click', this[$onARButtonContainerClick]);
                } else if (this[$arButtonContainer].classList.contains('enabled')) {
                  this[$arButtonContainer].removeEventListener('click', this[$onARButtonContainerClick]);
                  this[$arButtonContainer].classList.remove('enabled');
                  // If AR went from working to not, notify the element.
                  status = ARStatus.FAILED;
                  this.setAttribute('ar-status', status);
                  this.dispatchEvent(new CustomEvent('ar-status', {
                    detail: {
                      status: status
                    }
                  }));
                }
                this[$arMode] = arMode;
              case 55:
              case "end":
                return _context2.stop();
            }
          }, _callee2, this, [[4, 46, 49, 52]]);
        }));
        function value() {
          return _value.apply(this, arguments);
        }
        return value;
      }()
    }, {
      key: $enterARWithWebXR,
      value: function () {
        var _value3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
          var arRenderer;
          return _regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) switch (_context3.prev = _context3.next) {
              case 0:
                console.log('Attempting to present in AR with WebXR...');
                _context3.next = 3;
                return this[$triggerLoad]();
              case 3:
                _context3.prev = 3;
                this[$arButtonContainer].removeEventListener('click', this[$onARButtonContainerClick]);
                arRenderer = this[$renderer].arRenderer;
                arRenderer.placeOnWall = this.arPlacement === 'wall';
                _context3.next = 9;
                return arRenderer.present(this[$scene], this.xrEnvironment);
              case 9:
                _context3.next = 22;
                break;
              case 11:
                _context3.prev = 11;
                _context3.t0 = _context3["catch"](3);
                console.warn('Error while trying to present in AR with WebXR');
                console.error(_context3.t0);
                _context3.next = 17;
                return this[$renderer].arRenderer.stopPresenting();
              case 17:
                isWebXRBlocked = true;
                console.warn('Falling back to next ar-mode');
                _context3.next = 21;
                return this[$selectARMode]();
              case 21:
                this.activateAR();
              case 22:
                _context3.prev = 22;
                this[$selectARMode]();
                return _context3.finish(22);
              case 25:
              case "end":
                return _context3.stop();
            }
          }, _callee3, this, [[3, 11, 22, 25]]);
        }));
        function value() {
          return _value3.apply(this, arguments);
        }
        return value;
      }()
    }, {
      key: $triggerLoad,
      value: function () {
        var _value4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
          return _regeneratorRuntime.wrap(function _callee4$(_context4) {
            while (1) switch (_context4.prev = _context4.next) {
              case 0:
                if (this.loaded) {
                  _context4.next = 6;
                  break;
                }
                this[$preload] = true;
                this[$updateSource]();
                _context4.next = 5;
                return waitForEvent(this, 'load');
              case 5:
                this[$preload] = false;
              case 6:
              case "end":
                return _context4.stop();
            }
          }, _callee4, this);
        }));
        function value() {
          return _value4.apply(this, arguments);
        }
        return value;
      }()
    }, {
      key: $shouldAttemptPreload,
      value: function value() {
        return _get(_getPrototypeOf(ARModelViewerElement.prototype), $shouldAttemptPreload, this).call(this) || this[$preload];
      }
      /**
       * Takes a URL and a title string, and attempts to launch Scene Viewer on
       * the current device.
       */
    }, {
      key: $openSceneViewer,
      value: function value() {
        var _this2 = this;
        var location = self.location.toString();
        var locationUrl = new URL(location);
        var modelUrl = new URL(this.src, location);
        if (modelUrl.hash) modelUrl.hash = '';
        var params = new URLSearchParams(modelUrl.search);
        locationUrl.hash = noArViewerSigil;
        // modelUrl can contain title/link/sound etc.
        params.set('mode', 'ar_preferred');
        if (!params.has('disable_occlusion')) {
          params.set('disable_occlusion', 'true');
        }
        if (this.arScale === 'fixed') {
          params.set('resizable', 'false');
        }
        if (this.arPlacement === 'wall') {
          params.set('enable_vertical_placement', 'true');
        }
        if (params.has('sound')) {
          var soundUrl = new URL(params.get('sound'), location);
          params.set('sound', soundUrl.toString());
        }
        if (params.has('link')) {
          var linkUrl = new URL(params.get('link'), location);
          params.set('link', linkUrl.toString());
        }
        var intent = "intent://arvr.google.com/scene-viewer/1.2?".concat(params.toString() + '&file=' + encodeURIComponent(modelUrl.toString()), "#Intent;scheme=https;package=com.google.android.googlequicksearchbox;action=android.intent.action.VIEW;S.browser_fallback_url=").concat(encodeURIComponent(locationUrl.toString()), ";end;");
        var undoHashChange = function undoHashChange() {
          if (self.location.hash === noArViewerSigil) {
            isSceneViewerBlocked = true;
            // The new history will be the current URL with a new hash.
            // Go back one step so that we reset to the expected URL.
            // NOTE(cdata): this should not invoke any browser-level navigation
            // because hash-only changes modify the URL in-place without
            // navigating:
            self.history.back();
            console.warn('Error while trying to present in AR with Scene Viewer');
            console.warn('Falling back to next ar-mode');
            _this2[$selectARMode]();
            // Would be nice to activateAR() here, but webXR fails due to not
            // seeing a user activation.
          }
        };

        self.addEventListener('hashchange', undoHashChange, {
          once: true
        });
        this[$arAnchor].setAttribute('href', intent);
        console.log('Attempting to present in AR with Scene Viewer...');
        this[$arAnchor].click();
      }
      /**
       * Takes a URL to a USDZ file and sets the appropriate fields so that
       * Safari iOS can intent to their AR Quick Look.
       */
    }, {
      key: $openIOSARQuickLook,
      value: function () {
        var _value5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
          var generateUsdz, objectURL, modelUrl, location, locationUrl, srcUrl, anchor, img;
          return _regeneratorRuntime.wrap(function _callee5$(_context5) {
            while (1) switch (_context5.prev = _context5.next) {
              case 0:
                generateUsdz = !this.iosSrc;
                this[$arButtonContainer].classList.remove('enabled');
                if (!generateUsdz) {
                  _context5.next = 8;
                  break;
                }
                _context5.next = 5;
                return this.prepareUSDZ();
              case 5:
                _context5.t0 = _context5.sent;
                _context5.next = 9;
                break;
              case 8:
                _context5.t0 = this.iosSrc;
              case 9:
                objectURL = _context5.t0;
                modelUrl = new URL(objectURL, self.location.toString());
                if (generateUsdz) {
                  location = self.location.toString();
                  locationUrl = new URL(location);
                  srcUrl = new URL(this.src, locationUrl);
                  if (srcUrl.hash) {
                    modelUrl.hash = srcUrl.hash;
                  }
                }
                if (this.arScale === 'fixed') {
                  if (modelUrl.hash) {
                    modelUrl.hash += '&';
                  }
                  modelUrl.hash += 'allowsContentScaling=0';
                }
                anchor = this[$arAnchor];
                anchor.setAttribute('rel', 'ar');
                img = document.createElement('img');
                anchor.appendChild(img);
                anchor.setAttribute('href', modelUrl.toString());
                if (generateUsdz) {
                  anchor.setAttribute('download', 'model.usdz');
                }
                // attach anchor to shadow DOM to ensure iOS16 ARQL banner click message
                // event propagation
                anchor.style.display = 'none';
                if (!anchor.isConnected) this.shadowRoot.appendChild(anchor);
                console.log('Attempting to present in AR with Quick Look...');
                anchor.click();
                anchor.removeChild(img);
                if (generateUsdz) {
                  URL.revokeObjectURL(objectURL);
                }
                this[$arButtonContainer].classList.add('enabled');
              case 26:
              case "end":
                return _context5.stop();
            }
          }, _callee5, this);
        }));
        function value() {
          return _value5.apply(this, arguments);
        }
        return value;
      }()
    }, {
      key: "prepareUSDZ",
      value: function () {
        var _prepareUSDZ = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
          var updateSourceProgress, _this$$scene, model, shadow, target, visible, exporter, arraybuffer, blob, url;
          return _regeneratorRuntime.wrap(function _callee6$(_context6) {
            while (1) switch (_context6.prev = _context6.next) {
              case 0:
                updateSourceProgress = this[$progressTracker].beginActivity('usdz-conversion');
                _context6.next = 3;
                return this[$triggerLoad]();
              case 3:
                _this$$scene = this[$scene], model = _this$$scene.model, shadow = _this$$scene.shadow, target = _this$$scene.target;
                if (!(model == null)) {
                  _context6.next = 6;
                  break;
                }
                return _context6.abrupt("return", '');
              case 6:
                visible = false; // Remove shadow from export
                if (shadow != null) {
                  visible = shadow.visible;
                  shadow.visible = false;
                }
                updateSourceProgress(0.2);
                exporter = new USDZExporter();
                target.remove(model);
                model.position.copy(target.position);
                model.updateWorldMatrix(false, true);
                _context6.next = 15;
                return exporter.parse(model);
              case 15:
                arraybuffer = _context6.sent;
                model.position.set(0, 0, 0);
                target.add(model);
                blob = new Blob([arraybuffer], {
                  type: 'model/vnd.usdz+zip'
                });
                url = URL.createObjectURL(blob);
                updateSourceProgress(1);
                if (shadow != null) {
                  shadow.visible = visible;
                }
                return _context6.abrupt("return", url);
              case 23:
              case "end":
                return _context6.stop();
            }
          }, _callee6, this);
        }));
        function prepareUSDZ() {
          return _prepareUSDZ.apply(this, arguments);
        }
        return prepareUSDZ;
      }()
    }]);
    return ARModelViewerElement;
  }(ModelViewerElement, (_a = $canActivateAR, _b = $arButtonContainer, _c = $arAnchor, _d = $arModes, _e = $arMode, _f = $preload, _g = $onARButtonContainerClick, _h = $onARStatus, _j = $onARTracking, _k = $onARTap, $selectARMode));
  __decorate([property({
    type: Boolean,
    attribute: 'ar'
  })], ARModelViewerElement.prototype, "ar", void 0);
  __decorate([property({
    type: String,
    attribute: 'ar-scale'
  })], ARModelViewerElement.prototype, "arScale", void 0);
  __decorate([property({
    type: String,
    attribute: 'ar-placement'
  })], ARModelViewerElement.prototype, "arPlacement", void 0);
  __decorate([property({
    type: String,
    attribute: 'ar-modes'
  })], ARModelViewerElement.prototype, "arModes", void 0);
  __decorate([property({
    type: String,
    attribute: 'ios-src'
  })], ARModelViewerElement.prototype, "iosSrc", void 0);
  __decorate([property({
    type: Boolean,
    attribute: 'xr-environment'
  })], ARModelViewerElement.prototype, "xrEnvironment", void 0);
  return ARModelViewerElement;
};